import ConsolidationCenters from ".";

export const consolidationCenterRoutes = [
  {
    path: "/consolidationCenters",
    element: <ConsolidationCenters />,
  },
];
